/*!
 * Fonctions Javascript
 *
 *
 */

 /**
  * Fonction pour afficher un snackbar personnalisé
  * @param {*} text : le message à affiché
  */
 function snackbarperso(text){
  var snackbar = document.getElementById("snackbar");
  snackbar.className = "show";
  snackbar.innerHTML = text;

  setTimeout(function(){
    snackbar.className = snackbar.className.replace("show", "");
  },4000);

 }
